import React from 'react';

import LoadingIndicator from '~/components/loading-indicator';
import { centsToCurrency } from '~/utils/numbers';

import styles from '~/components/cart/cart-summary/cart-summary.module.scss';

const TaxLine = ({ taxAmount, isLoading = false }) => {
  return (
    <li className={styles.cartSummaryItem}>
      <span>Sales Tax</span>
      <span className={styles.cartSummaryItemValue} data-testid="tax">
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          centsToCurrency(taxAmount, {
            round: false,
          })
        )}
      </span>
    </li>
  );
};

export default TaxLine;
